//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RecipePhotosClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type AddPhotoRecipePhotosQueryParameters = {
  recipeId: number ;
  forInvestigationEditor?: boolean | undefined ;
  photo?: Types.FileParameter | null | undefined ;
}

export type AddPhotoRecipePhotosMutationParameters = {
  photo?: Types.FileParameter | null | undefined ;
}

export type GetPhotoRecipePhotosQueryParameters = {
  recipeId: number ;
  photoId: string ;
  width?: number | null | undefined ;
  height?: number | null | undefined ;
  resizeMode?: Types.ResizeMode | null | undefined ;
}

export type DeletePhotoRecipePhotosQueryParameters = {
  recipeId: number ;
  photoId: string ;
}

export type UpdatePhotoDescriptionRecipePhotosQueryParameters = {
  recipeId: number ;
  photoId: string ;
}

export function addPhotoUrl(recipeId: number, forInvestigationEditor?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/photo?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (forInvestigationEditor === null)
    throw new Error("The parameter 'forInvestigationEditor' cannot be null.");
else if (forInvestigationEditor !== undefined)
    url_ += "forInvestigationEditor=" + encodeURIComponent("" + forInvestigationEditor) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addPhotoMutationKey(recipeId: number, forInvestigationEditor?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'RecipePhotosClient',
      'addPhoto',
      recipeId as any,
      forInvestigationEditor as any,
    ]);
}

/**
 * Adds a photo of the recipe.
 * @param recipeId Id of the recipe.
 * @param forInvestigationEditor (optional) 
 * @param photo (optional) 
 */
export function useAddPhotoMutation<TContext>(recipeId: number, forInvestigationEditor?: boolean | undefined, options?: Omit<UseMutationOptions<Types.RecipePhotoDto, unknown, AddPhotoRecipePhotosMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RecipePhotoDto, unknown, AddPhotoRecipePhotosMutationParameters, TContext> {
  const key = addPhotoMutationKey(recipeId, forInvestigationEditor);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (addPhotoRecipePhotosMutationParameters: AddPhotoRecipePhotosMutationParameters) => Client.addPhoto(recipeId, forInvestigationEditor, addPhotoRecipePhotosMutationParameters.photo),
    mutationKey: key,
  });
}
  
type AddPhoto__MutationParameters = AddPhotoRecipePhotosQueryParameters & {
  addPhotoRecipePhotosMutationParameters: AddPhotoRecipePhotosMutationParameters;
}

/**
 * Adds a photo of the recipe.
 * @param recipeId Id of the recipe.
 * @param forInvestigationEditor (optional) 
 * @param photo (optional) 
 */
export function useAddPhotoMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RecipePhotoDto, unknown, AddPhoto__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: AddPhotoRecipePhotosQueryParameters}): UseMutationResult<Types.RecipePhotoDto, unknown, AddPhoto__MutationParameters, TContext> {
  const key = addPhotoMutationKey(options?.parameters?.recipeId!, options?.parameters?.forInvestigationEditor!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options, 
    mutationFn: (data: AddPhoto__MutationParameters) => Client.addPhoto(data.recipeId, data.forInvestigationEditor, data.photo),
    mutationKey: key,
  });
}
  
export function getPhotoUrl(recipeId: number, photoId: string, width?: number | null | undefined, height?: number | null | undefined, resizeMode?: Types.ResizeMode | null | undefined): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/photo/{photoId}?";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (photoId === undefined || photoId === null)
  throw new Error("The parameter 'photoId' must be defined.");
url_ = url_.replace("{photoId}", encodeURIComponent("" + photoId));
if (width !== undefined && width !== null)
    url_ += "width=" + encodeURIComponent("" + width) + "&";
if (height !== undefined && height !== null)
    url_ += "height=" + encodeURIComponent("" + height) + "&";
if (resizeMode !== undefined && resizeMode !== null)
    url_ += "resizeMode=" + encodeURIComponent("" + resizeMode) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPhotoDefaultOptions: Omit<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>, 'queryFn'>> = {
};
export function getGetPhotoDefaultOptions() {
  return getPhotoDefaultOptions;
};
export function setGetPhotoDefaultOptions(options: typeof getPhotoDefaultOptions) {
  getPhotoDefaultOptions = options;
}

export function getPhotoQueryKey(dto: GetPhotoRecipePhotosQueryParameters): QueryKey;
export function getPhotoQueryKey(recipeId: number, photoId: string, width?: number | null | undefined, height?: number | null | undefined, resizeMode?: Types.ResizeMode | null | undefined): QueryKey;
export function getPhotoQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { recipeId, photoId, width, height, resizeMode,  } = params[0] as GetPhotoRecipePhotosQueryParameters;

    return trimArrayEnd([
        'RecipePhotosClient',
        'getPhoto',
        recipeId as any,
        photoId as any,
        width as any,
        height as any,
        resizeMode as any,
      ]);
  } else {
    return trimArrayEnd([
        'RecipePhotosClient',
        'getPhoto',
        ...params
      ]);
  }
}
export function __getPhoto(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPhoto(
      context.queryKey[2] as number,       context.queryKey[3] as string,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as Types.ResizeMode | null | undefined,axiosConfig    );
}

export function useGetPhotoQuery<TSelectData = Types.FileResponse, TError = unknown>(dto: GetPhotoRecipePhotosQueryParameters, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a photo of the recipe.
 * @param recipeId Id of the recipe.
 * @param photoId Id of the recipe's photo.
 * @param width (optional) Width of the result photo.
 * @param height (optional) Height of the result photo.
 * @param resizeMode (optional) Mode describing how the photo should be resized.
 */
export function useGetPhotoQuery<TSelectData = Types.FileResponse, TError = unknown>(recipeId: number, photoId: string, width?: number | null | undefined, height?: number | null | undefined, resizeMode?: Types.ResizeMode | null | undefined, options?: Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPhotoQuery<TSelectData = Types.FileResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let recipeId: any = undefined;
  let photoId: any = undefined;
  let width: any = undefined;
  let height: any = undefined;
  let resizeMode: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ recipeId, photoId, width, height, resizeMode,  } = params[0] as GetPhotoRecipePhotosQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [recipeId, photoId, width, height, resizeMode, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FileResponse, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPhoto(context, axiosConfig) : __getPhoto,
    queryKey: getPhotoQueryKey(recipeId, photoId, width, height, resizeMode),
    ...getPhotoDefaultOptions as unknown as Omit<UseQueryOptions<Types.FileResponse, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a photo of the recipe.
 * @param recipeId Id of the recipe.
 * @param photoId Id of the recipe's photo.
 * @param width (optional) Width of the result photo.
 * @param height (optional) Height of the result photo.
 * @param resizeMode (optional) Mode describing how the photo should be resized.
 */
export function setGetPhotoData(queryClient: QueryClient, updater: (data: Types.FileResponse | undefined) => Types.FileResponse, recipeId: number, photoId: string, width?: number | null | undefined, height?: number | null | undefined, resizeMode?: Types.ResizeMode | null | undefined) {
  queryClient.setQueryData(getPhotoQueryKey(recipeId, photoId, width, height, resizeMode),
    updater
  );
}

/**
 * Gets a photo of the recipe.
 * @param recipeId Id of the recipe.
 * @param photoId Id of the recipe's photo.
 * @param width (optional) Width of the result photo.
 * @param height (optional) Height of the result photo.
 * @param resizeMode (optional) Mode describing how the photo should be resized.
 */
export function setGetPhotoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileResponse | undefined) => Types.FileResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function deletePhotoUrl(recipeId: number, photoId: string): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/photo/{photoId}";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (photoId === undefined || photoId === null)
  throw new Error("The parameter 'photoId' must be defined.");
url_ = url_.replace("{photoId}", encodeURIComponent("" + photoId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deletePhotoMutationKey(recipeId: number, photoId: string): MutationKey {
  return trimArrayEnd([
      'RecipePhotosClient',
      'deletePhoto',
      recipeId as any,
      photoId as any,
    ]);
}

/**
 * Deletes a photo of the recipe.
 * @param recipeId Id of the recipe.
 * @param photoId Recipe's photo id to be deleted.
 */
export function useDeletePhotoMutation<TContext>(recipeId: number, photoId: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deletePhotoMutationKey(recipeId, photoId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deletePhoto(recipeId, photoId),
    mutationKey: key,
  });
}
  
type DeletePhoto__MutationParameters = DeletePhotoRecipePhotosQueryParameters

/**
 * Deletes a photo of the recipe.
 * @param recipeId Id of the recipe.
 * @param photoId Recipe's photo id to be deleted.
 */
export function useDeletePhotoMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeletePhoto__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeletePhotoRecipePhotosQueryParameters}): UseMutationResult<void, unknown, DeletePhoto__MutationParameters, TContext> {
  const key = deletePhotoMutationKey(options?.parameters?.recipeId!, options?.parameters?.photoId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeletePhoto__MutationParameters) => Client.deletePhoto(data.recipeId ?? options?.parameters?.recipeId!, data.photoId ?? options?.parameters?.photoId!),
  mutationKey: key,
});
}
  
export function updatePhotoDescriptionUrl(recipeId: number, photoId: string): string {
  let url_ = getBaseUrl() + "/api/recipe/{recipeId}/photo/{photoId}/description";
if (recipeId === undefined || recipeId === null)
  throw new Error("The parameter 'recipeId' must be defined.");
url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
if (photoId === undefined || photoId === null)
  throw new Error("The parameter 'photoId' must be defined.");
url_ = url_.replace("{photoId}", encodeURIComponent("" + photoId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updatePhotoDescriptionMutationKey(recipeId: number, photoId: string): MutationKey {
  return trimArrayEnd([
      'RecipePhotosClient',
      'updatePhotoDescription',
      recipeId as any,
      photoId as any,
    ]);
}

/**
 * Updates the description of a recipe's photo.
 * @param recipeId Id of the recipe.
 * @param photoId Id of the recipe's photo.
 * @param description New description of the recipe's photo.
 */
export function useUpdatePhotoDescriptionMutation<TContext>(recipeId: number, photoId: string, options?: Omit<UseMutationOptions<string, unknown, string, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, string, TContext> {
  const key = updatePhotoDescriptionMutationKey(recipeId, photoId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (description: string) => Client.updatePhotoDescription(recipeId, photoId, description),
    mutationKey: key,
  });
}
  
type UpdatePhotoDescription__MutationParameters = UpdatePhotoDescriptionRecipePhotosQueryParameters & {
  description: string;
}

/**
 * Updates the description of a recipe's photo.
 * @param recipeId Id of the recipe.
 * @param photoId Id of the recipe's photo.
 * @param description New description of the recipe's photo.
 */
export function useUpdatePhotoDescriptionMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<string, unknown, UpdatePhotoDescription__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdatePhotoDescriptionRecipePhotosQueryParameters}): UseMutationResult<string, unknown, UpdatePhotoDescription__MutationParameters, TContext> {
  const key = updatePhotoDescriptionMutationKey(options?.parameters?.recipeId!, options?.parameters?.photoId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdatePhotoDescription__MutationParameters) => Client.updatePhotoDescription(data.recipeId ?? options?.parameters?.recipeId!, data.photoId ?? options?.parameters?.photoId!, data.description),
  mutationKey: key,
});
}